import { IHexGridData, IGameData, Place } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { BubbleFactory, regularColors } from 'js/bubbleCore/bubbles/BubbleFactory';
import { isInGrid } from 'js/bubbleCore/utils/isInGrid';
import { setGridValue } from 'js/bubbleCore/utils/setGridValue';
import { isSpaceFree } from 'js/bubbleCore/utils/isSpaceFree';
import { getAvailableColors } from 'js/bubbleCore/utils/getAvailableColors';
import { IEvent } from 'js/bubbleCore/events';
import { transferBubble } from 'js/bubbleCore/handlers/transferBubble';

export function fillRow(
  data: IGameData,
  factory: BubbleFactory,
  row: number,
  events: IEvent[],
): void {
  const { grid } = data;
  for (let col = 0; col < grid.limits.width; col++) {
    if (isInGrid(grid, col, row) && isSpaceFree(grid, col, row)) {
      transferBubble(factory.createRegular(col, row, getAvailableColors(data)), data, Place.Grid, events);
    } 
  }
}

export function fillRowParse(
  grid: IHexGridData<Bubble>,
  factory: BubbleFactory,
  row: number,
  numberOfColors: number,
): void {
  const colors = regularColors.slice(0, numberOfColors);
  for (let col = 0; col < grid.limits.width; col++) {
    if (isInGrid(grid, col, row) && isSpaceFree(grid, col, row)) {
      setGridValue(grid, col, row, factory.createRegular(col, row, colors));
    } 
  }
}